// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".investor[data-v-6b64d591]{display:flex;align-items:center}.investor .name[data-v-6b64d591]{padding:0 20px;flex:1 1 auto}.investor[data-v-6b64d591] .btn{padding:5px 10px}", ""]);
// Exports
module.exports = exports;
